export const FETCH_COMMUNITY_PROFILE_REQUEST =
  'FETCH_COMMUNITY_PROFILE_REQUEST';
export const FETCH_COMMUNITY_PROFILE_SUCCESS =
  'FETCH_COMMUNITY_PROFILE_SUCCESS';
export const FETCH_COMMUNITY_PROFILE_FAILURE =
  'FETCH_COMMUNITY_PROFILE_FAILURE';

export const UPDATE_COMMUNITY_PROFILE_REQUEST =
  'UPDATE_COMMUNITY_PROFILE_REQUEST';
export const UPDATE_COMMUNITY_PROFILE_SUCCESS =
  'UPDATE_COMMUNITY_PROFILE_SUCCESS';
export const UPDATE_COMMUNITY_PROFILE_FAILURE =
  'UPDATE_COMMUNITY_PROFILE_FAILURE';

export const COMMUNITY_SET_IS_LOADING = 'COMMUNITY_SET_IS_LOADING';

export const UPDATE_COMMUNITY_PROFILE_PIC_REQUEST =
  'UPDATE_COMMUNITY_PROFILE_PIC_REQUEST';

export const FETCH_SUGGESTED_GROUPS_REQUEST = 'FETCH_SUGGESTED_GROUPS_REQUEST';
export const FETCH_SUGGESTED_GROUPS_SUCCESS = 'FETCH_SUGGESTED_GROUPS_SUCCESS';
export const FETCH_SUGGESTED_GROUPS_FAILURE = 'FETCH_SUGGESTED_GROUPS_FAILURE';

export const FETCH_MY_GROUPS_REQUEST = 'FETCH_MY_GROUPS_REQUEST';
export const FETCH_MY_GROUPS_SUCCESS = 'FETCH_MY_GROUPS_SUCCESS';
export const FETCH_MY_GROUPS_FAILURE = 'FETCH_MY_GROUPS_FAILURE';
export const REMOVE_MY_GROUP = 'REMOVE_MY_GROUP';
export const ADD_MY_GROUP = 'ADD_MY_GROUP';
export const REMOVE_SUGGESTED_GROUP = 'REMOVE_SUGGESTED_GROUP';

export const FETCH_NOTIFICATIONS_REQUEST = 'FETCH_NOTIFICATIONS_REQUEST';
export const FETCH_NOTIFICATIONS_SUCCESS = 'FETCH_NOTIFICATIONS_SUCCESS';
export const FETCH_NOTIFICATIONS_FAILURE = 'FETCH_NOTIFICATIONS_FAILURE';

export const MARK_NOTIFICATION_READ_REQUEST = 'MARK_NOTIFICATION_READ_REQUEST';
export const MARK_ALL_NOTIFICATIONS_READ_REQUEST =
  'MARK_ALL_NOTIFICATIONS_READ_REQUEST';
export const DELETE_NOTIFICATION_REQUEST = 'DELETE_NOTIFICATION_REQUEST';
export const DELETE_ALL_NOTIFICATIONS_REQUEST =
  'DELETE_ALL_NOTIFICATIONS_REQUEST';

export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const UPDATE_NOTIFICATION_READ = 'UPDATE_NOTIFICATION_READ';
export const UPDATE_ALL_NOTIFICATIONS_READ = 'UPDATE_ALL_NOTIFICATIONS_READ';
export const CLEAR_ALL_NOTIFICATIONS = 'CLEAR_ALL_NOTIFICATIONS';
